// Utilities
import { defineStore } from 'pinia'
import { api, apiWithoutAuth, registerapi } from '@/plugins/axios'
import { AuthTokenService } from '@/handler/authService';

export const useRegisterStore = defineStore('regAuth', {
  state: () => ({
    formData: {
      user_full_name: null,
      country: null,
      country_code: null,
      phone_number: null,
      referred_by_code: null,
      email: null,
      password: null
    },
    isAuthenticate: false,
    authState: {
      success: null,
      error: null
    },
    customPasswords: {
      password: null,
      confirm_password: null,
    },
  }),
  getters: {
    getFormData: (state) => state.formData,
  },
  actions: {
    storePassword(name, password) {
      name === 'password' ? this.customPasswords.password = password : this.customPasswords.confirm_password = password;
    },

    rememberAuth() {
      const rememberAuth = JSON.parse(localStorage.getItem('rememberAuthObj'))
      this.formData = {...rememberAuth}
    },

    asignCountryCode() {
      this.formData.country_code = this.formData.country.code
    },

    async authCheck() {
      try {
        const response = await api.get('user/checkauth/');
        this.authState.success = response.detail
      } catch(error) {
        this.authState.error = error.response.data.detail
      }
    },
    async validate(){
       await apiWithoutAuth.post('user/validate-registration/' , {email : this.formData.email})
    },
    async register(){
      let url = 'user/register/';
      // if (this.formData.referred_by_code !== null && this.formData.referred_by_code !== undefined) {
      //   url += `?referred_by_code=${this.formData.referred_by_code}`;
      // }
      //for test only
    //  await apiWithoutAuth.post(url, this.formData)
     return await apiWithoutAuth.post(url, this.formData)
     // test end
    },
    async socialRegister (accessToken){
      let url = 'user/firebase/signup/';
      const response = await apiWithoutAuth.post(url, {...this.formData, ...{idToken: accessToken}});
      return response.data
    },
    async sendEmailVerificationOtp (){
      let url = 'user/send-verification-otp/';
      const userEmail = AuthTokenService.getEmail();
      const response = await registerapi.post(url, { email : this.formData.email || userEmail });
      return response.data
    }
  },

})
